import '../../styles/bitacora.style.css'
import { useDispatch, useSelector } from 'react-redux'
import BasicCardDocumentos from '../DatosDeCierre/BasicCardDocumentos'
import { State } from '../../../../reducers'
import { useEffect, useState } from 'react'
import { Pagination } from '../../../../components/Pagination';
import FilterButton from '../../../../components/Tables/TableComponent/FilterButton'
import { Tooltip } from '../../../../components/Tooltip/Tooltip'

import DeleteIcon from '../../../../media/felsv/DarkRecycleDelete.svg';
import ModalConfirm from '../../../../components/Modals/Generales/ModalConfirm'
import { deleteLibroComprasDetalle, editClasificacionCompras } from '../../../../actions/libros/libro-compras.actions'
import { PanelClasificacionCompras, SelectClasificacion } from '../LibroCompras/PanelClasificacionCompras'
import { CAMPO_DETALLE, CAMPOS_CODIGO, CampoCodigo, Codigos, calcularAplicacion, esCodigoValido, mensajeAplicacion, periodoExigeClasificacion } from '../../../../utils/codificacion-compras.utils'

const TableDetalleCompras = () => {
  const {comprasLibroActivo} = useSelector((state: State) => state.libros);
  const {detalle, libroActivo} = comprasLibroActivo;
  const [currentItems, setCurrentItems] = useState<Array<any>>([]);
  const [sortedArray, setSortedArray] = useState<Array<any>>([]);
  const [modalConfirmDelete, setModalConfirmDelete] = useState<boolean> (false);
  const [selectedDetalle, setSelectedDetalle] = useState<any>(null);

  // Cambios de clasificacion hechos en pantalla y aun sin guardar (clave: numcorrelativo)
  const [cambios, setCambios] = useState<Record<string, Partial<Codigos>>>({});
  // Se cambia al guardar para que el panel olvide el aviso "Se aplicó a N compras. Pulse Guardar…"
  const [versionPanel, setVersionPanel] = useState<number>(0);

  const dispatch = useDispatch();

  useEffect(() => {
    setSortedArray(currentItems);
  }, [currentItems]);

  // Al abrir otro libro se descartan los cambios sin guardar del anterior
  useEffect(() => {
    setCambios({});
  }, [libroActivo?.idlibrocompras]);

  // Desde febrero 2024 las 4 columnas son obligatorias; libroActivo.fechadeclaracion llega como AAAA-MM (o formatos viejos)
  const exige = periodoExigeClasificacion(libroActivo?.fechadeclaracion);

  const valorCodigo = (item: any, campo: CampoCodigo): number => Number(cambios[item.numcorrelativo]?.[campo] ?? item[CAMPO_DETALLE[campo]] ?? 0) || 0;
  const guardado = (item: any, campo: CampoCodigo): number => Number(item[CAMPO_DETALLE[campo]] ?? 0) || 0;
  const tieneCambios = (item: any): boolean => CAMPOS_CODIGO.some((campo) => valorCodigo(item, campo) !== guardado(item, campo));

  const compras: Array<any> = detalle ?? [];
  const pendientes = compras.filter((item) => CAMPOS_CODIGO.some((campo) => !esCodigoValido(campo, valorCodigo(item, campo)))).length;
  const comprasConCambios = compras.filter(tieneCambios);

  const handleCambioCodigo = (item: any, campo: CampoCodigo, valor: number) => {
    setCambios((prev) => ({ ...prev, [item.numcorrelativo]: { ...prev[item.numcorrelativo], [campo]: valor } }));
  }

  // Aplica lo elegido en el panel a todas las compras o solo a las pendientes (queda sin guardar hasta pulsar "Guardar cambios")
  const handleAplicar = (masivo: Codigos, soloSinClasificar: boolean): string => {
    const { parches, compras: aplicadas } = calcularAplicacion(compras, (item) => String(item.numcorrelativo), valorCodigo, masivo, soloSinClasificar);
    setCambios((prev) => {
      const siguiente = { ...prev };
      Object.entries(parches).forEach(([clave, parche]) => { siguiente[clave] = { ...siguiente[clave], ...parche }; });
      return siguiente;
    });
    return mensajeAplicacion(aplicadas) + (aplicadas > 0 ? ' Pulse "Guardar cambios" para conservarlo.' : '');
  }

  const handleGuardarCambios = async () => {
    const items = comprasConCambios.map((item) => ({
      numcorrelativo: Number(item.numcorrelativo),
      tipooperacion: valorCodigo(item, 'tipoOperacion'),
      clasificacion: valorCodigo(item, 'clasificacion'),
      sector: valorCodigo(item, 'sector'),
      tipoclasificacion: valorCodigo(item, 'tipoClasificacion'),
    }));
    if (await dispatch(editClasificacionCompras(libroActivo, items))) {
      setCambios({});
      setVersionPanel((v) => v + 1);
    }
  }

  const handleConfirmEliminarDetalle = (detalleLibro: any) => {
    setSelectedDetalle(detalleLibro);
    setModalConfirmDelete(true);
  }

  const handleEliminarDetalleLibro = async () => {
    if (await dispatch(deleteLibroComprasDetalle(selectedDetalle, comprasLibroActivo.libroActivo))) {
      setModalConfirmDelete(false);
    } 
  }

  return (
    <div className="w-layout-layout bill-section wf-layout-layout">
      {
        modalConfirmDelete && 
          <ModalConfirm 
            title={'Eliminar registro'} 
            detail={'Estás a punto de eliminar el registro del libro de compras. ¿Deseas continuar?'}
            closeModalConfirm={() => setModalConfirmDelete(false)} 
            actionConfirm={() => handleEliminarDetalleLibro()} 
          />
      }
      <BasicCardDocumentos 
        style={{boxShadow: 'none', padding: '0'}} 
        title="Detalle de libro" 
        size="l"
      >
        <PanelClasificacionCompras
          key={versionPanel}
          exige={exige}
          total={compras.length}
          pendientes={pendientes}
          onAplicar={handleAplicar}
          pie={exige && (
            <div style={{ display: 'flex', alignItems: 'center', gap: '16px', flexWrap: 'wrap', marginTop: '12px' }}>
              <button className="button w-auto" disabled={comprasConCambios.length === 0} onClick={handleGuardarCambios}>Guardar cambios</button>
              <span className="s" style={{ color: comprasConCambios.length > 0 ? '#7a4b00' : '#4a5562' }}>
                {comprasConCambios.length > 0
                  ? `${comprasConCambios.length} ${comprasConCambios.length === 1 ? 'compra con cambios' : 'compras con cambios'} sin guardar`
                  : 'No hay cambios sin guardar'}
              </span>
            </div>
          )}
        />
        <div className="tab-plane">
          <div className="table-facturacion-resp">
            <table className="table-main-responsive responsive-table-main td-left table-pointer">
              <thead>
                <tr>
                  <td>Acciones</td>
                  <td>No. <FilterButton keyName='numcorrelativo' data={sortedArray} state={(items: Array<any>) => setSortedArray(items)}/></td>
                  <td>Fecha Emisión <FilterButton keyName='fechaemision' data={sortedArray} state={(items: Array<any>) => setSortedArray(items)}/></td>
                  <td>Número Comprobante <FilterButton keyName='numcomprobante' data={sortedArray} state={(items: Array<any>) => setSortedArray(items)}/></td>
                  <td>Número Registro <FilterButton keyName='numregistro' data={sortedArray} state={(items: Array<any>) => setSortedArray(items)}/></td>
                  <td>Nombre Proveedor <FilterButton keyName='nombreproveedor' data={sortedArray} state={(items: Array<any>) => setSortedArray(items)}/></td>
                  <td>Exentas Locales <FilterButton keyName='exentaslocales' data={sortedArray} state={(items: Array<any>) => setSortedArray(items)}/></td>
                  <td>Exentas Importaciones <FilterButton keyName='exentasimportacion' data={sortedArray} state={(items: Array<any>) => setSortedArray(items)}/></td>
                  <td>Exentas Internacionales <FilterButton keyName='exentasinternacional' data={sortedArray} state={(items: Array<any>) => setSortedArray(items)}/></td>
                  <td>Gravadas Locales <FilterButton keyName='gravadaslocales' data={sortedArray} state={(items: Array<any>) => setSortedArray(items)}/></td>
                  <td>Gravadas Importaciones <FilterButton keyName='gravadasimportacion' data={sortedArray} state={(items: Array<any>) => setSortedArray(items)}/></td>
                  <td>Gravadas Internacionales <FilterButton keyName='gravadasinternacional' data={sortedArray} state={(items: Array<any>) => setSortedArray(items)}/></td>
                  <td>Crédito Fiscal IVA <FilterButton keyName='creditofiscaliva' data={sortedArray} state={(items: Array<any>) => setSortedArray(items)}/></td>
                  <td>Total Compras <FilterButton keyName='totalcompras' data={sortedArray} state={(items: Array<any>) => setSortedArray(items)}/></td>
                  <td>Percepción <FilterButton keyName='percepcion' data={sortedArray} state={(items: Array<any>) => setSortedArray(items)}/></td>
                  <td>Retención <FilterButton keyName='retencion' data={sortedArray} state={(items: Array<any>) => setSortedArray(items)}/></td>
                  <td>Tipo Operación <FilterButton keyName='tipooperacion' data={sortedArray} state={(items: Array<any>) => setSortedArray(items)}/></td>
                  <td>Clasificación <FilterButton keyName='clasificacion' data={sortedArray} state={(items: Array<any>) => setSortedArray(items)}/></td>
                  <td>Tipo Costo/Gasto <FilterButton keyName='tipoclasificacion' data={sortedArray} state={(items: Array<any>) => setSortedArray(items)}/></td>
                  <td>Sector <FilterButton keyName='sector' data={sortedArray} state={(items: Array<any>) => setSortedArray(items)}/></td>
                </tr>
              </thead>
              <tbody>
                {
                  sortedArray?.length > 0 && 
                  (
                    sortedArray.map((item: any) => (
                      <tr key={item.numcorrelativo}>
                        <td data-label='Acciones' className='table-td'>
                          <Tooltip content='Eliminar Registro'>
                            <button className='table-action' onClick={(e) => handleConfirmEliminarDetalle(item)}>
                              <img src={DeleteIcon} alt='Eliminar registro' className='table-img-action' />
                            </button>
                          </Tooltip>
                        </td>
                        <td data-label='No.'>{item.numcorrelativo}</td>
                        <td data-label='Fecha Emisión'>{item.fechaemision}</td>
                        <td data-label='Número Comprobante'>{item.numcomprobante}</td>
                        <td data-label='Número Registro'>{item.numregistro}</td>
                        <td data-label='Nombre Proveedor'>{item.nombreproveedor}</td>
                        <td data-label='Exentas Locales'>{item.exentaslocales}</td>
                        <td data-label='Exentas Importaciones'>{item.exentasimportacion}</td>
                        <td data-label='Exentas Internacionales'>{item.exentasinternacional}</td>
                        <td data-label='Gravadas Locales'>{item.gravadaslocales}</td>
                        <td data-label='Gravadas Importaciones'>{item.gravadasimportacion}</td>
                        <td data-label='Gravadas Internacionales'>{item.gravadasinternacional}</td>
                        <td data-label='Crédito Fiscal IVA'>{item.creditofiscaliva}</td>
                        <td data-label='Total Compras'>{item.totalcompras}</td>
                        <td data-label='Percepción'>{item.percepcion}</td>
                        <td data-label='Retención'>{item.retencion}</td>
                        <td data-label='Tipo Operación'><SelectClasificacion campo='tipoOperacion' valor={valorCodigo(item, 'tipoOperacion')} exige={exige} onChange={(valor) => handleCambioCodigo(item, 'tipoOperacion', valor)} /></td>
                        <td data-label='Clasificación'><SelectClasificacion campo='clasificacion' valor={valorCodigo(item, 'clasificacion')} exige={exige} onChange={(valor) => handleCambioCodigo(item, 'clasificacion', valor)} /></td>
                        <td data-label='Tipo Costo/Gasto'><SelectClasificacion campo='tipoClasificacion' valor={valorCodigo(item, 'tipoClasificacion')} exige={exige} onChange={(valor) => handleCambioCodigo(item, 'tipoClasificacion', valor)} /></td>
                        <td data-label='Sector'><SelectClasificacion campo='sector' valor={valorCodigo(item, 'sector')} exige={exige} onChange={(valor) => handleCambioCodigo(item, 'sector', valor)} /></td>
                      </tr>
                    ))
                  )
                }
              </tbody>
            </table>
            {detalle?.length > 0 && (
              <Pagination
                data={detalle}
                state={(items: Array<any>) => setCurrentItems(items)}
                items={20}
              />
            )}
          </div>
        </div>
      </BasicCardDocumentos>
    </div>
  )
}

export default TableDetalleCompras
